export default {

    data: function () {
        return {
            svcPages: {}
        };
    },

    mounted: function () {
        this.svcPages = this.getSvcPages();
    },

    methods: {
        // fetch PublicOnly svc/pages
        getSvcPages: function () {
            return this.$store.dispatch('pages/fetchPagesPublicOnly')
                .then((value) => {
                    this.svcPages = value; // this.pagesPublicOnly;
                })
                .catch(() => {
                    console.warn("PublicOnly Pages not found");
                });

        }
    }
};
